import styled from '@emotion/styled';

import Button from '../Button';

/**
 * `eye-slash-outline.svg` hardcodes `fill="white"` (unlike `eye-outline.svg`,
 * which uses `currentColor`), so without this both toggle states would not
 * track the button's text color. Scoped here instead of editing the shared
 * asset, which other screens rely on.
 */
export const StyledRevealToggleButton = styled(Button)({
  'svg [fill]:not([fill="none"])': {
    fill: 'currentColor',
  },
});
